export default __webpack_public_path__ + "static/media/5.c8b524be.png";